export const HIRING = 'hiring';
export const ADDON = 'addon';
export const SLUGS = 'slugs';
